// +-------------------------------------------------------------
// | Created by WebStorm.
// +-------------------------------------------------------------
// | User: msmile
// +-------------------------------------------------------------
// | Date: 2025/5/14
// +-------------------------------------------------------------
// |Time: 16:56
// +-------------------------------------------------------------
export default [
    {
        path: '/management/goods-list',
        name: "GoodsList",
        meta: {
            title: "商品列表"
        },
        component: () => import("@/views/Management/Goods/Index")
    }
]